import { GridColDef } from "@mui/x-data-grid-premium";

const columnsHandler = () => {
  return [
    {
      field: "id",
      headerName: "",
      width: 70,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      hide: true,
    },
    {
      field: "nomeUtente",
      headerName: "Nome utente",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "descrizioneGruppo",
      headerName: "Gruppo",
      width: 250,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "eMail",
      headerName: "Email",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "attivo",
      headerName: "Attivo",
      width: 80,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "center",
      align: "center",
      type: "boolean",
    },
    {
      field: "user",
      headerName: "User",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "left",
    },
  ] as GridColDef[];
};
export default columnsHandler;
